module.exports = __webpack_public_path__ + "img/concrete_masonry.a94836f0.jpg";